export const removeFilteredItems = (
    checkboxes: string[],
    filtersHeadedQueriedColumnData: string[],
) => {
    return checkboxes.filter(item => !filtersHeadedQueriedColumnData.includes(item));
};
